import {useQuery} from 'react-query'
import {Get} from '../../../../../setup'
import {SAVTickets, useSAV} from '../../../../@types'
import {Dispatch, SetStateAction, useMemo} from 'react'
import {LoadingState, PeriodType} from '../../../../../global'

const TICKETS_LIST = process.env.REACT_APP_SAV_TICKETS_LIST || 'sav/list-ticket'

type Props = {
    period: PeriodType
    setLoading: Dispatch<SetStateAction<LoadingState>>
}

export const useTicketsDataTable = ({period, setLoading}: Props) => {

    const {reloadKey, status} = useSAV()

    const {data, isLoading, isFetching, isError} = useQuery(
        ['TICKETS_DATATABLE', reloadKey, period],
        () => Get<SAVTickets>({endpoint: TICKETS_LIST, period}),
        {
            onSuccess: () => setLoading('fulfilled'),
            select: (response) => response.tickets || [],
            staleTime: 30000,
            cacheTime: 300000,
            retry: 2,
        },
    )

    const transformedTickets = useMemo(() =>
            data?.map(ticket => ({
                ...ticket,
                status: status.find(s => s.name === ticket.status) ||
                    {id: 0, name: ticket.status, color: 'default'},
            })) || [],
        [data, status])

    return { data: transformedTickets, isLoading, isFetching, isError };
}